import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../../services/authConfig';

const AuthButton: React.FC = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('Login error:', e);
    });
  };

  const handleLogout = () => {
    // Pass the specific account so MSAL clears the correct session and
    // Entra External ID properly ends the federated (Google/Microsoft) session.
    instance.logoutRedirect({
      account: accounts[0] ?? null,
      postLogoutRedirectUri: window.location.origin,
    }).catch((e) => {
      console.error('Logout error:', e);
    });
  };

  if (!isAuthenticated) {
    return (
      <button
        onClick={handleLogin}
        className="px-6 py-2 bg-gold-500 text-dark-900 font-semibold rounded-lg hover:bg-gold-400 transition-colors"
      >
        Sign In
      </button>
    );
  }

  return (
    <div className="flex items-center gap-4">
      <span className="text-sm text-gray-300">
        {accounts[0]?.name || accounts[0]?.username}
      </span>
      <button
        onClick={handleLogout}
        className="px-4 py-2 bg-dark-700 text-gray-300 text-sm rounded-lg hover:bg-dark-600 transition-colors"
      >
        Sign Out
      </button>
    </div>
  );
};

export default AuthButton;
